export const PARTNERS = {
  CARMAX: 'kmx',
  CARWISER: 'carwiser',
  CARWISER3: 'carwiser3',
  AUTONATION: 'autonation',
  CASHFORCARS: 'cashforcars',
  ECHOPARK: 'echopark',
  ICO: 'ico',
};
